// @ts-nocheck
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  fill: {
    flex: '1',
  },
}));

function LoadingWrapper(props) {
  const classes = useStyles();

  const { children, loading } = props;

  if (loading) {
    return <Skeleton id="LoadingWrapper-placeholder" variant="rect" className={classes.fill} />;
  }
  return children;
}

LoadingWrapper.defaultProps = {
  children: undefined,
};

LoadingWrapper.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool.isRequired,
};

export default LoadingWrapper;
